import React from 'react';
import styles from './ExtendedSelect.module.scss';
import Select from 'react-select';
// eslint-disable-next-line import/no-unresolved
import { Styles } from 'react-select/lib/styles';
import { isArray } from 'util';
import { formDetector } from '_helpers';
import classNames from 'classnames';

const ExtendedSelect = ({
    value,
    name,
    withoutDetectChanges,
    withoutStrictValue,
    isInvalid,
    options,
    multi,
    onChangeMulti,
    onChange,
    className,
    noOptionsMessage,
    disabled,
    placeholder,
    notSelectedOptions,
    onMenuOpen,
    subText,
    invalidTitle,
    smSize,
}: Props) => {
    React.useEffect(() => {
        if (value && !isArray(value) && !withoutDetectChanges) {
            formDetector.setChangedInput(name, value);
        }
    }, [value]);

    const customStyle: Styles = {
        control: base => ({
            ...base,
            border: isInvalid ? '1px solid #dc3545 !important' : '',
        }),
    };

    const multiOptions: string[] | null = value && isArray(value) ? value as string[] : null;
    const selectedOptions = options.filter(x => (multiOptions && multiOptions.length && multiOptions.find(option => x.value === option)));
    const findValue = options.find(x => x.value === value);

    const onChangeSelect = (e: any) => {
        if (multi && onChangeMulti) {
            onChangeMulti(e);
        } else {
            onChange({
                name,
                value: e && e.value && e.value as string,
            });
            if (!withoutDetectChanges) {
                formDetector.setChangedInput(name, e.value as string);
            }
        }
    };

    return (
        <div className={classNames(styles.container, className)} data-test-extended-select>
            <Select
              noOptionsMessage={() => noOptionsMessage || 'Нет опций'}
              isDisabled={disabled}
              isMulti={multi}
              styles={customStyle}
              name={name}
              className={classNames('react-select-container', smSize && 'react-select-container_size_sm')}
              classNamePrefix="react-select"
              defaultValue={selectedOptions}
              value={withoutStrictValue ? findValue : (findValue || null)}
              onChange={onChangeSelect}
              options={notSelectedOptions || options}
              placeholder={placeholder || 'Выберите из списка'}
              onMenuOpen={onMenuOpen}
            />
            {subText ? (
                <div className={styles.feedbackText}>
                    {subText}
                </div>
            )
                : null}
            {isInvalid && invalidTitle ? (
                <div className={`${styles.feedbackText} mt-1 text-danger`}>
                    {invalidTitle || null}
                </div>
            )
                : null}
        </div>
    );
};

export default ExtendedSelect;

export interface IOption {
    value: string;
    label: string;
}

export interface ISelectEvent {
    name: string;
    value: string;
}

interface Props {
    name: string;
    options: IOption[];
    notSelectedOptions?: IOption[];
    value?: string | string[] | null;
    className?: string;
    placeholder?: string;
    disabled?: boolean;
    isInvalid?: boolean;
    invalidTitle?: string;
    subText?: string;
    noOptionsMessage?: string;
    multi?: boolean;
    withoutDetectChanges?: boolean;
    withoutStrictValue?: boolean;
    smSize?: boolean;
    onChange: (event: ISelectEvent) => void;
    onChangeMulti?: (event: ISelectEvent[]) => void;
    onMenuOpen?: () => void;
}
